module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/minus-d4c217c9dc0836620c207fc59dc9975b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/minus.svg
// module id = zJsq
// module chunks = 24